/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseAggregatedSestData } from '../models/ApiResponseAggregatedSestData';
import type { ApiResponseAggregatedSestResponse } from '../models/ApiResponseAggregatedSestResponse';
import type { ApiResponseGetLastOdometerResponse } from '../models/ApiResponseGetLastOdometerResponse';
import type { ApiResponseListSestData } from '../models/ApiResponseListSestData';
import type { ApiResponseListSestItem } from '../models/ApiResponseListSestItem';
import type { ApiResponseVoid } from '../models/ApiResponseVoid';
import type { CreateSestCommand } from '../models/CreateSestCommand';
import type { OdometerRequest } from '../models/OdometerRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class MaintenancesSestControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 누적주행거리 조회
   * 누적주행거리를 조회합니다.
   * @returns ApiResponseGetLastOdometerResponse OK
   * @throws ApiError
   */
  public getLastOdometer({
    vin,
    ccid,
    authorization,
  }: {
    vin: string,
    ccid: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetLastOdometerResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/maintenances/cars/{vin}/odometer/',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
      query: {
        'ccid': ccid,
      },
    });
  }
  /**
   * 누적주행거리 업데이트
   * 누적주행거리를 업데이트합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public updateOdometer({
    vin,
    requestBody,
  }: {
    vin: string,
    requestBody: OdometerRequest,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/maintenances/cars/{vin}/odometer/',
      path: {
        'vin': vin,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 누적주행거리 등록
   * 누적주행거리를 등록합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public createOdometer({
    vin,
    requestBody,
  }: {
    vin: string,
    requestBody: OdometerRequest,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/maintenances/cars/{vin}/odometer/',
      path: {
        'vin': vin,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 누적주행거리 조회
   * 누적주행거리를 조회합니다.
   * @returns ApiResponseGetLastOdometerResponse OK
   * @throws ApiError
   */
  public getLastOdometer1({
    vin,
    ccid,
    authorization,
  }: {
    vin: string,
    ccid: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetLastOdometerResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/maintenances/cars/{vin}/odometer',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
      query: {
        'ccid': ccid,
      },
    });
  }
  /**
   * 누적주행거리 업데이트
   * 누적주행거리를 업데이트합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public updateOdometer1({
    vin,
    requestBody,
  }: {
    vin: string,
    requestBody: OdometerRequest,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/maintenances/cars/{vin}/odometer',
      path: {
        'vin': vin,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 누적주행거리 등록
   * 누적주행거리를 등록합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public createOdometer1({
    vin,
    requestBody,
  }: {
    vin: string,
    requestBody: OdometerRequest,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/maintenances/cars/{vin}/odometer',
      path: {
        'vin': vin,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 소모품 목록 및 교환이력 조회
   * 차량의 소모품 목록 및 교환이력을 조회합니다.
   * @returns ApiResponseAggregatedSestResponse OK
   * @throws ApiError
   */
  public getAggregatedSestList({
    authorization,
    vin,
    ccid,
    csmrMgmtNo,
  }: {
    authorization?: string,
    vin: string,
    ccid: string,
    csmrMgmtNo?: string,
  }): CancelablePromise<ApiResponseAggregatedSestResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/maintenances/cars/{vin}/sest',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
      query: {
        'ccid': ccid,
        'csmrMgmtNo': csmrMgmtNo,
      },
    });
  }
  /**
   * 최초 주행일 등록
   * 차량의 최초 주행일을 등록합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public createSest({
    vin,
    requestBody,
  }: {
    vin: string,
    requestBody: CreateSestCommand,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/maintenances/cars/{vin}/sest',
      path: {
        'vin': vin,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 소모품 목록 및 교환이력 조회
   * 차량의 소모품 목록 및 교환이력을 조회합니다.
   * @returns ApiResponseAggregatedSestResponse OK
   * @throws ApiError
   */
  public getAggregatedSestList1({
    authorization,
    vin,
    ccid,
    csmrMgmtNo,
  }: {
    authorization?: string,
    vin: string,
    ccid: string,
    csmrMgmtNo?: string,
  }): CancelablePromise<ApiResponseAggregatedSestResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/maintenances/cars/{vin}/sest/',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
      query: {
        'ccid': ccid,
        'csmrMgmtNo': csmrMgmtNo,
      },
    });
  }
  /**
   * 최초 주행일 등록
   * 차량의 최초 주행일을 등록합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public createSest1({
    vin,
    requestBody,
  }: {
    vin: string,
    requestBody: CreateSestCommand,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/maintenances/cars/{vin}/sest/',
      path: {
        'vin': vin,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 특정 소모품 교환이력 조회
   * 차량의 특정 소모품 교환이력을 조회합니다.
   * @returns ApiResponseAggregatedSestData OK
   * @throws ApiError
   */
  public getSest({
    authorization,
    vin,
    sestCode,
    ccid,
  }: {
    authorization?: string,
    vin: string,
    sestCode: string,
    ccid: string,
  }): CancelablePromise<ApiResponseAggregatedSestData> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/maintenances/cars/{vin}/sest/{sestCode}/',
      path: {
        'vin': vin,
        'sestCode': sestCode,
      },
      headers: {
        'Authorization': authorization,
      },
      query: {
        'ccid': ccid,
      },
    });
  }
  /**
   * 특정 소모품 교환이력 조회
   * 차량의 특정 소모품 교환이력을 조회합니다.
   * @returns ApiResponseAggregatedSestData OK
   * @throws ApiError
   */
  public getSest1({
    authorization,
    vin,
    sestCode,
    ccid,
  }: {
    authorization?: string,
    vin: string,
    sestCode: string,
    ccid: string,
  }): CancelablePromise<ApiResponseAggregatedSestData> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/maintenances/cars/{vin}/sest/{sestCode}',
      path: {
        'vin': vin,
        'sestCode': sestCode,
      },
      headers: {
        'Authorization': authorization,
      },
      query: {
        'ccid': ccid,
      },
    });
  }
  /**
   * 소모품 목록 및 교환이력 조회 (정비소 데이터만 조회)
   * 차량의 소모품 목록 및 교환이력을 조회합니다. (정비소 데이터 Only)
   * @returns ApiResponseListSestData OK
   * @throws ApiError
   */
  public getSestListFromServiceCenter({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseListSestData> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/maintenances/cars/{vin}/sest/-/service-center',
      path: {
        'vin': vin,
      },
    });
  }
  /**
   * 소모품 목록 및 교환이력 조회 (정비소 데이터만 조회)
   * 차량의 소모품 목록 및 교환이력을 조회합니다. (정비소 데이터 Only)
   * @returns ApiResponseListSestData OK
   * @throws ApiError
   */
  public getSestListFromServiceCenter1({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseListSestData> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/maintenances/cars/{vin}/sest/-/service-center/',
      path: {
        'vin': vin,
      },
    });
  }
  /**
   * 소모품 항목 조회
   * 소모품 항목을 조회합니다.
   * @returns ApiResponseListSestItem OK
   * @throws ApiError
   */
  public getSestItems(): CancelablePromise<ApiResponseListSestItem> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/maintenances/cars/-/sest-items/',
    });
  }
  /**
   * 소모품 항목 조회
   * 소모품 항목을 조회합니다.
   * @returns ApiResponseListSestItem OK
   * @throws ApiError
   */
  public getSestItems1(): CancelablePromise<ApiResponseListSestItem> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/maintenances/cars/-/sest-items',
    });
  }
}
